import { BulkOperationResult } from '@rideiq/api/services/Riders';
import { useToastStore } from '@rideiq/shared/stores/toastStore';

interface BulkOperationResultToastMessages {
  allSucceeded: (succeededCount: number) => string;
  allFailed: (failedCount: number) => string;
  partial: (succeededCount: number, failedCount: number) => string;
}

export const useBulkOperationResultToast = () => {
  const { addToast } = useToastStore();

  const showResultsToast = (results: BulkOperationResult[], messages: BulkOperationResultToastMessages) => {
    const succeededCount = results.filter((result) => result.status === 'success').length;
    const failedCount = results.length - succeededCount;

    if (failedCount === 0) {
      addToast({ severity: 'success', message: messages.allSucceeded(succeededCount) });
    } else if (succeededCount === 0) {
      addToast({ severity: 'error', message: messages.allFailed(failedCount) });
    } else {
      addToast({ severity: 'warning', message: messages.partial(succeededCount, failedCount) });
    }
  };

  return { showResultsToast };
};
